import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { toast } from 'react-toastify';

type ChatwootCredentialsDialogProps = {
  open: boolean;
  apiAccessToken: string;
  hmacSignatureKey: string | null;
  agentBotApiKey: string | null;
  onClose: () => void;
};

async function copyValue(value: string, label: string): Promise<void> {
  await navigator.clipboard.writeText(value);
  toast.success(`${label} copiado`);
}

export function ChatwootCredentialsDialog({
  open,
  apiAccessToken,
  hmacSignatureKey,
  agentBotApiKey,
  onClose,
}: ChatwootCredentialsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={value => !value && onClose()}>
      <DialogContent className='max-w-lg'>
        <DialogHeader>
          <DialogTitle>Credenciales del canal</DialogTitle>
          <DialogDescription className='text-amber-700 font-medium'>
            El API token y las claves opcionales no se volverán a mostrar. Copialas ahora.
          </DialogDescription>
        </DialogHeader>
        <div className='space-y-4'>
          <div>
            <p className='text-sm font-medium mb-1'>API access token</p>
            <code className='block text-xs break-all bg-muted p-2 rounded'>{apiAccessToken}</code>
            <Button
              type='button'
              size='sm'
              variant='outline'
              className='mt-2'
              onClick={() => void copyValue(apiAccessToken, 'API token')}
            >
              <Copy className='h-4 w-4 mr-1' />
              Copiar token
            </Button>
          </div>
          {hmacSignatureKey && (
            <div>
              <p className='text-sm font-medium mb-1'>HMAC signature key</p>
              <code className='block text-xs break-all bg-muted p-2 rounded'>{hmacSignatureKey}</code>
              <Button
                type='button'
                size='sm'
                variant='outline'
                className='mt-2'
                onClick={() => void copyValue(hmacSignatureKey, 'HMAC key')}
              >
                <Copy className='h-4 w-4 mr-1' />
                Copiar HMAC
              </Button>
            </div>
          )}
          {agentBotApiKey && (
            <div>
              <p className='text-sm font-medium mb-1'>Agent bot API key</p>
              <code className='block text-xs break-all bg-muted p-2 rounded'>{agentBotApiKey}</code>
              <Button
                type='button'
                size='sm'
                variant='outline'
                className='mt-2'
                onClick={() => void copyValue(agentBotApiKey, 'Agent bot key')}
              >
                <Copy className='h-4 w-4 mr-1' />
                Copiar agent bot key
              </Button>
            </div>
          )}
          <Button type='button' className='w-full' onClick={onClose}>
            Entendido, ya las guardé
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
